import React, { useMemo, useState } from 'react';
import { string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ContextMenu, { Item, Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import { useThemes } from '@core/hooks';
import { signOutUser } from '@core/components/src/XAuth/redux/actions';
import UserPanelInfo from './UserPanelInfo/UserPanelInfo';
import UserPanelPopup from './UserPanelPopup/UserPanelPopup';

const UserPanel = ({ menuMode }) => {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const {
    isDark,
    setThemeDark,
    setThemeDarkCompact,
    setThemeLight,
    setThemeLightCompact
  } = useThemes();

  const themesItems = useMemo(
    () => [
      {
        text: 'Ciemny',
        icon: isDark ? 'isblank' : 'isnotblank',
        onClick: setThemeDark
      },
      {
        text: 'Ciemny Compact',
        icon: isDark ? 'isblank' : 'isnotblank',
        onClick: setThemeDarkCompact
      },
      {
        text: 'Jasny',
        icon: isDark ? 'isnotblank' : 'isblank',
        onClick: setThemeLight
      },
      {
        text: 'Jasny Compact',
        icon: isDark ? 'isnotblank' : 'isblank',
        onClick: setThemeLightCompact
      }
    ],
    [isDark]
  );

  const { data } = useSelector(({ user }) => ({
    data: user.data
  }));

  const { login } = data;

  const protectedKeys = ['jwt', 'refreshToken'];

  const handleResetSettingsClick = () => {
    for (let i = 0; i < localStorage.length; i++) {
      if (!protectedKeys.includes(localStorage.key(i) ?? '')) {
        localStorage.removeItem(localStorage.key(i) ?? '');
      }
    }
  };

  return (
    <div className="user-panel">
      <div className="user-info">
        <div className={isDark ? 'user-name--light user-name' : 'user-name'}>
          <i className={isDark ? 'dx-icon-card' : 'dx-icon-card darkFont'} />
          <b className={isDark ? '' : 'darkFont'}>{login}</b>
        </div>
      </div>

      {menuMode === 'context' && (
        <ContextMenu
          target=".user-button"
          showEvent="dxclick"
          width={230}
          cssClass={`user-menu ${isDark ? 'user-menu--dark' : ''}`}
        >
          <Position my="top center" at="bottom center" />
          <Item render={() => <UserPanelInfo setVisible={setVisible} />} />
          <Item
            text="Logout"
            icon="runner"
            onClick={() => dispatch(signOutUser())}
          />
          <Item
            text="Motyw"
            icon="fill"
            cssClass="user-menu__themes"
            items={themesItems}
          />
          <Item
            text="Zresetuj do ustawień domyślnych"
            icon="preferences"
            onClick={handleResetSettingsClick}
          />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <>
          <List className="dx-toolbar-menu-action" />
        </>
      )}
      {visible ? (
        <UserPanelPopup visible={visible} setVisible={setVisible} />
      ) : null}
    </div>
  );
};

UserPanel.propTypes = {
  menuMode: string
};

export default UserPanel;
